import React from "react";

import Button from "../Button";

import * as ctaStyles from "./Cta.module.css";

const Cta = ({ backgroundColor, props }) => {
  const { headline, subHeadline, action } = props;

  let textColor;
  if (backgroundColor === "blue") {
    textColor = "white";
  }

  return (
    <div className={ctaStyles.cta}>
      <div
        className={`${ctaStyles.content} ${ctaStyles[textColor]}`}
        // data-aos="fade-in"
      >
        <h5 className={ctaStyles.headline}>{headline}</h5>
        {subHeadline && <p>{subHeadline}</p>}
      </div>
      <div
      // data-aos="fade-in"
      >
        <Button props={action} destination={action.to}>
          {action.title}
        </Button>
      </div>
    </div>
  );
};

export default Cta;
